export { HelpArticlesDirective } from './lib/help-articles.directive';

export type { HelpTranslationLinkMapKey } from './lib/types';

export { HelpTranslationLinkMap } from './lib/types';
